/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ITrafficLogsStates, TrafficLogsStore } from '../../traffic-logs.store';
import './traffic-logs-collapsed-sidebar.component.less';

/**
 * @description
 *
 *     Component for setting the icon list view of collapsed log sidebar.
 *
 * @author Zhiqian Liu, Yogesh Patil
 */
@Component({
    selector: 'traffic-logs-collapsed-sidebar',
    templateUrl: './traffic-logs-collapsed-sidebar.component.html',
})
export class TrafficLogsCollapsedSidebarComponent implements OnInit {
    /**
     * List of single icon name for the upper search section column.
     */
    public readonly searchSectionIconList = ['star'];

    /**
     * List of icon names for generating the collapsed-state sidebar lower icon column section.
     * The default set is for L7/L4 logs.
     */
    public dataSectionIconList = [
        'shield',
        'user',
        'share',
        'switch',
        'exclamation-circle',
    ];

    constructor(private readonly logsStore: TrafficLogsStore<ITrafficLogsStates>) {}

    /** @override */
    public ngOnInit(): void {
        this.logsStore.vsConfig$
            .pipe(take(1))
            .subscribe(({ isDNS }) => {
                if (isDNS) {
                    this.dataSectionIconList.shift();
                }
            });
    }
}
